import React, { memo } from 'react'
import clsx from 'clsx'
import IconButton from '@material-ui/core/IconButton'
import ArrowRounderBackIcon from '@material-ui/icons/ArrowBack'
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForward'
import ArrowBackIcon from '@material-ui/icons/KeyboardArrowLeft'
import ArrowForwardIcon from '@material-ui/icons/KeyboardArrowRight'
import PropTypes from 'prop-types'
import Slider from '../Slider'
import { CONTROL_VARIANT } from './ControlledSlider.const'
import { useControlledSlider } from './ControlledSlider.hooks'

const ControlledSlider = props => {
	const [
		{ sliderRef, classes, settings, controlVariant },
		{ handleNextClick, handlePrevClick },
	] = useControlledSlider(props)

	return (
		<div className={clsx(classes[controlVariant], `slider-${controlVariant}-root`)}>
			<Slider ref={sliderRef} {...settings} />
			{
				{
					[CONTROL_VARIANT.WIDE]: (
						<div className={clsx(classes.control, `slider-buttons`)}>
							<IconButton
								onClick={handlePrevClick}
								className={clsx(classes.button, 'slider-arrow-left-button')}
							>
								<ArrowRounderBackIcon className={clsx(classes.icon, 'slider-arrow-left-icon')} />
							</IconButton>
							<IconButton
								onClick={handleNextClick}
								className={clsx(classes.button, 'slider-arrow-right-button')}
							>
								<ArrowForwardRoundedIcon className={clsx(classes.icon, 'slider-arrow-right-icon')} />
							</IconButton>
						</div>
					),
					[CONTROL_VARIANT.CENTERED]: (
						<div className={clsx(classes.control, 'slider-buttons')}>
							<IconButton
								onClick={handlePrevClick}
								className={clsx(classes.button, 'slider-arrow-left-button')}
							>
								<ArrowBackIcon className={clsx(classes.icon, 'slider-arrow-left-icon')} />
							</IconButton>
							<IconButton
								onClick={handleNextClick}
								className={clsx(classes.button, 'slider-arrow-right-button')}
							>
								<ArrowForwardIcon className={clsx(classes.icon, 'slider-arrow-right-icon')} />
							</IconButton>
						</div>
					),
				}[controlVariant]
			}
		</div>
	)
}

ControlledSlider.propTypes = {
	children: PropTypes.node.isRequired,
	accessibility: PropTypes.bool,
	adaptiveHeight: PropTypes.bool,
	afterChange: PropTypes.func,
	appendDots: PropTypes.func,
	arrows: PropTypes.bool,
	asNavFor: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.instanceOf(Element) }), // If you pass a ref object
	]),
	autoplay: PropTypes.bool,
	autoplaySpeed: PropTypes.number,
	beforeChange: PropTypes.func,
	centerMode: PropTypes.bool,
	centerPadding: PropTypes.string,
	className: PropTypes.string,
	customPaging: PropTypes.func,
	dots: PropTypes.bool,
	dotsClass: PropTypes.string,
	draggable: PropTypes.bool,
	easing: PropTypes.string,
	fade: PropTypes.bool,
	focusOnSelect: PropTypes.bool,
	infinite: PropTypes.bool,
	initialSlide: PropTypes.number,
	lazyLoad: PropTypes.oneOf(['ondemand', 'progressive']),
	onEdge: PropTypes.func,
	onInit: PropTypes.func,
	onLazyLoad: PropTypes.func,
	onReInit: PropTypes.func,
	onSwipe: PropTypes.func,
	pauseOnDotsHover: PropTypes.bool,
	pauseOnFocus: PropTypes.bool,
	pauseOnHover: PropTypes.bool,
	responsive: PropTypes.arrayOf(
		PropTypes.shape({
			breakpoint: PropTypes.number.isRequired,
			settings: PropTypes.object.isRequired,
		}),
	),
	rows: PropTypes.number,
	rtl: PropTypes.bool,
	slide: PropTypes.string,
	slidesPerRow: PropTypes.number,
	slidesToScroll: PropTypes.number,
	slidesToShow: PropTypes.number,
	speed: PropTypes.number,
	swipe: PropTypes.bool,
	swipeToSlide: PropTypes.bool,
	touchMove: PropTypes.bool,
	touchThreshold: PropTypes.number,
	useCSS: PropTypes.bool,
	useTransform: PropTypes.bool,
	variableWidth: PropTypes.bool,
	vertical: PropTypes.bool,
	controlVariant: PropTypes.oneOf(['wide', 'centered']),
}

ControlledSlider.defaultProps = {
	controlVariant: 'wide',
}

export default memo(ControlledSlider)
